import { FormControl, Grid, Paper, TextField } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { IFilteringViewModel } from "../../_common/interface/table";
import StyledGrid from "../../_components/grid/styledGrid";
import { PageHeader } from "../../_components/header/page.header";
import { CommonTable } from "../../_components/table/common.table";
import { toastr } from "../../_components/toastr/toastr";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { userCreditService } from "../../_services/userCredit.service";
import { useContainerStyles } from "../../_styles/container.styles";
import { UserCreditManageDrawer } from "./userCredit-manageDrawer";
import { getDate, getDateTime } from "../../_helpers/dateTime.helper";
import { accountService } from "../../_services/accounts.service";


export function UserCreditIndex() {

    const [data, setData] = useState<any>({ items: [], count: 0 });
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [isLoading, setLoading] = useState(true);
    const [filter, setFilter] = useState<IFilteringViewModel>();

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'userName',
                header: 'User',
            },
            {
                accessorKey: 'createdBy',
                header: 'Created By',
            },
            {
                accessorKey: 'eventDate',
                header: 'Event Date',
                accessorFn: (rowData: any) => <>{rowData.eventDate ? getDate(rowData.eventDate) : "-"}</>,
            },
            {
                accessorKey: 'usedDate',
                header: 'Used Date',
                accessorFn: (rowData: any) => <>{rowData.usedDate ? getDate(rowData.usedDate) : "-"}</>,
            },
        ],
        [],
    );

    useEffect(() => {
        if(filter)
            fetchData();
    }, [filter]);

    function fetchData() {
        setLoading(true);

        return userCreditService.getAll({ ...filter })
            .then(
                data => {
                    setData(data);
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }
    function onDelete(id: number) {
        setLoading(true);
        return userCreditService
            .disable(id)
            .then(
                () => {
                    fetchData();
                    toastr.success(" Motorsport Licence Type disabled successfully");
                }, handleErrorResponse
            )
            .finally(() => setLoading(false));
    }
    function handleChange(event: any) {
        setFilter((__filter: any) => { return { ...__filter, [event.target.name]: event.target.value } });
    };


    return (

        <>
            <div style={useContainerStyles.root}>

                <PageHeader
                    pageName="User Credits"
                    buttonName="User Credits"
                    onClick={() => setSelectedId(0)}
                    actionType="create"
                />

                <Paper>

                    <ValidatorForm onSubmit={fetchData}>

                        <StyledGrid container spacing={2}>

                            <Grid item lg={3} md={6} xs={12}>
                                <FormControl fullWidth>
                                    <TextField label="Name" name="name" value={filter?.name} onChange={handleChange} placeholder="Name" variant="outlined" />
                                </FormControl>
                            </Grid>

                        </StyledGrid>

                    </ValidatorForm>

                    <CommonTable
                        columns={columns}
                        data={data}
                        filter={filter}
                        onEdit={setSelectedId}
                        setFilter={(_filter) => { setFilter({ ...filter, ..._filter }) }}
                        isLoading={isLoading}
                    />
                    
                    {!!accountService.isAdmin &&
                        <UserCreditManageDrawer
                            isOpen={selectedId != null}
                            itemId={selectedId}
                            onSave={() => { setSelectedId(null); fetchData(); }}
                            onClose={() => { setSelectedId(null); fetchData(); }}
                        />
                    }
                </Paper>

            </div>
        </>


    );

}
